import React from 'react';
import PropTypes from 'prop-types';

import { formatLocaleDate } from '../../../utils';

import styles from './logDetails.module.scss';

const formatDowntimeRange = ({ from, to }) => {
  const formattedFrom = formatLocaleDate(from, 'yyyy-MM-dd HH:mm:ss');
  const formattedTo = formatLocaleDate(to, 'yyyy-MM-dd HH:mm:ss');

  return `${formattedFrom} – ${formattedTo}`;
};

const DowntimeHistory = ({ downtimeHistory }) => {
  const hasHistory = Boolean(downtimeHistory?.length);

  return (
    <div className={styles.downtimeHistorySection}>
      <h2 className={styles.downtimeHistoryTitle}>Prastovos istorija</h2>
      {hasHistory ? (
        <ul className={styles.downtimeHistoryList}>
          {downtimeHistory.map((entry, index) => (
            <li key={`${entry.from}-${entry.to}-${index}`}>
              {formatDowntimeRange(entry)}
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.downtimeHistoryEmpty}>Nėra prastovų</p>
      )}
    </div>
  );
};

DowntimeHistory.propTypes = {
  downtimeHistory: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    })
  ),
};

DowntimeHistory.defaultProps = {
  downtimeHistory: [],
};

export default DowntimeHistory;
